import { Typography } from "@mui/material";
import useStore from "../../hooks/useStore";
import { AgendaDiv } from "../../styles/styles";

const EmptyAgenda = () => {
  const { height, translations } = useStore();
  return (
    <AgendaDiv
      sx={{
        borderWidth: 1,
        padding: 1,
        height: height / 2,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div >
        <Typography>{translations.noDataToDisplay}</Typography>
      </div>
    </AgendaDiv>
  );
};

export default EmptyAgenda;
